/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスキットのサムネイルとして利用する画像URL
 * @export
 * @interface PressKitThumbnailUrls
 */
export interface PressKitThumbnailUrls {
    /**
     * 詳細表示するときに使うwidth:480pxの画像。別ドメイン。Fastly経由でサイズはバックエンドが決める。
     * @type {string}
     * @memberof PressKitThumbnailUrls
     */
    w480: string;
    /**
     * 詳細表示するときに使うwidth:720pxの画像。別ドメイン。Fastly経由でサイズはバックエンドが決める。
     * @type {string}
     * @memberof PressKitThumbnailUrls
     */
    w720: string;
    /**
     * 詳細表示するときに使うwidth:960pxの画像。別ドメイン。Fastly経由でサイズはバックエンドが決める。
     * @type {string}
     * @memberof PressKitThumbnailUrls
     */
    w960: string;
    /**
     * 詳細表示するときに使うwidth:1480pxの画像。別ドメイン。Fastly経由でサイズはバックエンドが決める。
     * @type {string}
     * @memberof PressKitThumbnailUrls
     */
    w1480: string;
}

/**
 * Check if a given object implements the PressKitThumbnailUrls interface.
 */
export function instanceOfPressKitThumbnailUrls(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "w480" in value;
    isInstance = isInstance && "w720" in value;
    isInstance = isInstance && "w960" in value;
    isInstance = isInstance && "w1480" in value;

    return isInstance;
}

export function PressKitThumbnailUrlsFromJSON(json: any): PressKitThumbnailUrls {
    return PressKitThumbnailUrlsFromJSONTyped(json, false);
}

export function PressKitThumbnailUrlsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitThumbnailUrls {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'w480': json['w480'],
        'w720': json['w720'],
        'w960': json['w960'],
        'w1480': json['w1480'],
    };
}

export function PressKitThumbnailUrlsToJSON(value?: PressKitThumbnailUrls | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'w480': value.w480,
        'w720': value.w720,
        'w960': value.w960,
        'w1480': value.w1480,
    };
}

